<template>
  <vbt-dialog
    v-model="dialog"
    title="Create barcode"
    width="500px"
    submit-btn-name="Create"
    @submit="submitForm"
    @close="onDialogClose"
  >
    <v-form :ref="formRef">
      <v-text-field
        v-model.trim="form.barcode"
        :rules="validator.getRulesByField('barcode')"
        label="Barcode"
        @keypress.enter="submitForm"
      />
      <v-text-field
        v-model.trim="form.description"
        label="Description"
        @keypress.enter="submitForm"
      />
    </v-form>
  </vbt-dialog>
</template>

<script>
import { useDialog, useFormWithRef } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import UsersApiService from '../_services/users.api.service';

import { generateUserBarcodeModel } from '../_models/user.model';

const validator = Validator.createValidator({ barcode: ['required'] });

export default {
  name: 'UmsUserBarcodeEditor',
  mixins: [
    useDialog(),
    useFormWithRef(),
    Validator.useValidator(validator),
  ],
  data: () => ({ form: generateUserBarcodeModel() }),
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.$_validateForm()) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: 'Create barcode?',
      }, () => this.wrapToLoadingFn({
        req: UsersApiService.createdUserBarcode.bind({}, {
          id: this.$route.params.id,
          barcode: this.form.barcode,
          description: this.form.description,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('User barcode successfully created');
          this.$emit('change:success');
          this.$_closeDialog();
        },
      }));
    },
    onDialogClose() {
      this.$nextTick(() => {
        this.$_resetFormValidation();
        this.$_resetForm();
      });
    },
  },
};
</script>
